let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5N3rX")).then(() => parcelRequire('gt3Bn'));